import { useContext, useEffect, useRef, useState } from "react";
import "./Authenticator.css";
import QRCode from 'qrcode.react';
import { LocaleContext, StateContext } from "./App";
import { LoadState, TwoFactorAuthType } from "./enums.mjs";
import { Loading, NavigateSmart } from "./Common";
import { ErrorComp } from "./Common";
import { Navigate, useLocation } from "react-router-dom";
import { useAutoLoad } from "./hooks";
import { TwoFactorAuth } from "./TwoFactorAuth";

export function Authenticator(props) {
    const [provisioningUri, setProvisioningUri] = useState("");
    const [showCopied, setShowCopied] = useState(false);

    const state = useContext(StateContext);
    const locale = useContext(LocaleContext);


    // EFFECTS:

    const [loadState, setLoadState] = useAutoLoad((json) => {
        // On load success
        setProvisioningUri(json.uri);
    }, () => {
        // On load error
    }, () => {
        return "/user/setup_two_factor_auth_app";
    });

    useEffect(() => {
        function handleClickAnywhere(e) {
            setShowCopied(false);
        }

        document.addEventListener("pointerdown", handleClickAnywhere);
        return () => document.removeEventListener("pointerdown", handleClickAnywhere);
    }, []);
    

    // RENDER:

    const key = provisioningUri.substring(provisioningUri.indexOf("secret="), provisioningUri.indexOf("&issuer")).split("=")[1];
    
    return (
        <div id="authenticator">
            { loadState === LoadState.LOADING ?
                <div className="setup_authenticator_loading">
                    <Loading management={props.management} />
                </div>
            :
                loadState === LoadState.LOAD_ERROR ?
                    <ErrorComp text={locale.msgs.GENERAL_ERROR_DESCR} />
                :
                    loadState === LoadState.LOAD_SUCCESS ?
                        <div className="authenticator_content">
                            <div className="head">{locale.msgs.SETUP_TWO_FACTOR}</div>
                            <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.SETUP_TWO_FACTOR_DESCR}}></div>
                            <div className="text_big scan_qr_code_text">{locale.msgs.SCAN_QR_CODE}</div>
                            <div id="auth_qr_code_box">
                                <QRCode value={provisioningUri} />
                            </div>
                            <div className="text_big scan_qr_code_text">{locale.msgs.OR_USE_SETUP_KEY}</div>

                            <div id="scan_qr_code_key" className="text scan_qr_code_text">
                                <div id="scan_qr_code_key_key">{key}</div>

                                <div className="scan_qr_code_key_copy_img_box">
                                    <img id="scan_qr_code_key_copy_img" src="/common/icon_link.svg" onClick={(e) => {

                                            // Does not work on Safari IOS if HTTP is used. It does work with HTTPS!
                                            navigator.clipboard.writeText(key).then(() => {
                                                // console.log('Text copied to clipboard');
                                                setShowCopied(true);
                                            }).catch(err => {
                                                console.error('Could not copy text to clipboard', err);
                                            });

                                            // window.Clipboard.copy(key);
                                    }}/>

                                    { showCopied ?
                                        <div className="text_success_4 scan_qr_code_key_copy_img_copied">{locale.msgs.COPIED}</div>
                                    :
                                        null
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    :
                        null
            }
        </div>
    );
}
